import { useContext } from 'react';
import SectionWrapper from '@/home/common/SectionWrapper';
import LoadingVehicleCarousel from '@/home/common/VehicleCarousel/LoadingVehicleCarousel';
import { VdpCardType } from '~/constants/home/VdpCardType';
import GlobalContext from '~/context/home/GlobalContext';
import RecentlyViewed from './RecentlyViewed';
import SuggestedForYou from './SuggestedForYou';

export default function TopCarousels() {
  const { vdpCardTypeShown, isVdpLinksLoaded } = useContext(GlobalContext);
  const isRecentlyViewedInVdpLinks = vdpCardTypeShown === VdpCardType.Recent;

  if (!isVdpLinksLoaded) {
    return (
      <SectionWrapper analyticsSection={'Top Carousels'}>
        <LoadingVehicleCarousel hasBottomBorder />
        <LoadingVehicleCarousel />
      </SectionWrapper>
    );
  }

  return (
    <>
      {isRecentlyViewedInVdpLinks ? (
        <>
          <SuggestedForYou />
          <RecentlyViewed />
        </>
      ) : (
        <>
          <RecentlyViewed />
          <SuggestedForYou />
        </>
      )}
    </>
  );
}
